export enum DiffMileageUnit {
    Km = 'km',
    Percent = '%',
};

export enum FutureMileageCalcMode {
    Computed = 'Aktuální nájezd',
    Custom = 'Vlastní',
};

export enum RecalculateOption {
    No = 'Ne - rozdíly v nájezdech jsou do stanoveného limitu',
    Yes = 'Ano',
    YesMaxMileage = 'Ano - z důvodu překročení maximálního povoleného nájezdu',
}